import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BaseRequest } from '../models/base-request.model';
import { Observable } from 'rxjs';
import { BaseResponse } from '../models/base-response.model';
import { CookieService } from './cookie.service';

@Injectable({ providedIn: 'root' })
export class CustomTrackingService {

  cookieService = inject(CookieService);
  apiUrl = 'api/';

  constructor() {
    if(!this.cookieService.check('SessionId')){
      this.cookieService.setSessionId();
    }
  }

  registerCookie(): void {
        if (this.cookieService.check('ct2')) {
            return;
        }

        const uid = crypto.randomUUID();

        const d1 = new Date();
        const d2 = new Date(d1);
        d2.setMinutes(d1.getMinutes() + 30);

        const domain = window.location.hostname.replace('issuing', '').replace('www', '').replace('onlinelc', '');

        this.cookieService.set('ct2', `t=${uid}`, d2, '/', domain, false, undefined, (val) => val);
    }
}
